module.exports = __webpack_public_path__ + "media/images/like_this_cmnd_back-d403421251458e63874ff21585bd6ef1.jpg";